import Config from '../../commons/config/Config.js'
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import { MODAL_RESET_TIMEOUT_MS } from '../constants/modal.js';

let _ajaxHandler403Showing = false;

class AjaxHandler {
	constructor(component) {
		this.component = null;
	}

	subscribe(component) {
		this.component = component;
	}

	unsubscribe(component) {
		this.component = null;
	}

	getJson(service) {
		if(this.component) {
			return new Promise((resolve, reject) => {
				this.fetch(service, {
					method: 'GET',
				}).then(response => {
					if(this.component) {
						resolve(response.json());
					} else {
						return null;
					}
				}).catch(error => {
                    if(error.name === 'AbortError'){
                        reject(error);
                        return;
                    }
					if(this.component) {
						reject(error);
					} else {
						return null;
					}
				});
			});
		} else {
			console.log('AjaxHandler: Component not subscribed.');
			return null;
		}
	}

	getJsonOptions(service,options){
		if(this.component) {
			return new Promise((resolve, reject) => {
				this.fetch(service, options).then(response => {
					if(this.component) {
						resolve(response.json());
					} else {
						return null;
					}
				}).catch(error => {
          if(error.name === 'AbortError'){
              reject(error);
              return;
          }
					if(this.component) {
						reject(error);
					} else {
						return null;
					}
				});
			});
		} else {
			console.log('AjaxHandler: Component not subscribed.');
			return null;
		}
	}

	// This method supports FormData sending (multipart/form-data)
	// For example, it is used for forms where the backend waits ($_FILES).
	// It is also contemplated and supported that FormData is not sent.
	// In the future it could be evaluated to discontinue the original fecht method for this one.
	fetchMultipart(service, options) {
		if(this.component) {
			return new Promise((resolve, reject) => {
				const isFormData = options && options.body && options.body instanceof FormData;
				
				const headers = {
					'Accept': 'application/json',
					'Authorization-Token': localStorage.getItem("token")
				};
				
				if (!isFormData) {
					headers['Content-Type'] = 'application/json';
				}
				
				fetch(Config.get('apiUrlBase') + service,
					Object.assign(options, { headers })
				)
				.then(response => {
					if(this.component) {
						this.handleResponseErrorsIsValid(response.clone())
						.then(error => {
							if(!error) {
								resolve(response);
							} else {
								var httpErr = new TypeError(error);
								httpErr.status = response.status;
								reject(httpErr);
							}
						});
					} else {
						return null;
					}
				}).catch(error => {
					if (error.name === 'AbortError') {return;}
					if(this.component) {
						if(error) this.handleError(error);
						reject(error);
					} else {
						return null;
					}
				});
			});
		} else {
			console.log('AjaxHandler: Component not subscribed.');
			return null;
		}
	}

	// This method does not support FormData sending (multipart/form-data)
	// For example, it does not work for forms where the backend waits ($_FILES).
	// For that use fetchMultipart
	//
	// `options.silent === true` suprime el popup genérico de error de red (`handleError`)
	// y el de 5xx (>= 404), permitiendo que el caller maneje el error inline. Los popups
	// de 401/403 se mantienen porque son auth-críticos. La promise sigue rechazando, así
	// que el caller debe manejarlo en `.catch()`.
	//
	// Para fallos HTTP, el TypeError rechazado lleva `err.status` con el HTTP status code,
	// de modo que el caller puede distinguir 403/404/5xx (HTTP) de errores reales de
	// transporte (network/CORS/abort) donde `err.status` queda undefined.
	fetch(service, options) {
		if(this.component) {
			return new Promise((resolve, reject) => {
				var silent = options && options.silent === true;
				var fetchOptions = Object.assign({}, options);
				if (fetchOptions.silent !== undefined) {
					delete fetchOptions.silent;
				}
				fetch(Config.get('apiUrlBase') + service,
					Object.assign(fetchOptions, {
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'Authorization-Token': localStorage.getItem("token")
						}
					})
				)
				.then(response => {
					if(this.component) {
						this.handleResponseErrorsIsValid(response.clone(), silent)
						.then(error => {
							if(!error) {
								resolve(response);
							} else {
								var httpErr = new TypeError(error);
								httpErr.status = response.status;
								reject(httpErr);
							}
						});
					} else {
						return null;
					}
				}).catch(error => {
					if (error.name === 'AbortError') {return;}
					if(this.component) {
						if(error && !silent) this.handleError(error);
						reject(error);
					} else {
						return null;
					}
				});
			});
		} else {
			console.log('AjaxHandler: Component not subscribed.');
			return null;
		}
	}

	handleResponseErrorsIsValid(response, silent) {
		let component = this.component;
		return new Promise((resolve, reject) => {
			let message, detail, messageResponse, detailResponse;
			if(response.status === 401) {
				message = component.props.intl.formatMessage({ id: 'ajaxHandler.errors_401.error_la_sesion_expiro', defaultMessage: 'La sesión expiró.' });
				detail = component.props.intl.formatMessage({ id: 'ajaxHandler.errors_401.error_por_favor_ingrese_nuevamente', defaultMessage: 'Por favor, ingrese nuevamente.' });
			} else if(response.status === 403) {
				message = component.props.intl.formatMessage({ id: 'ajaxHandler.errors_403.error_no_tiene_permisos_para_realizar_esta_accion', defaultMessage: 'No tiene permisos para realizar esta acción.' });
				detail = component.props.intl.formatMessage({ id: 'ajaxHandler.errors_403.error_contacte_al_administrador', defaultMessage: 'Contacte al administrador.' });
			} else if(response.status >= 404) {
				message = component.props.intl.formatMessage({ id: 'ajaxHandler.errors_404.error_interno_del_sistema', defaultMessage: 'Error interno del sistema.' });
				detail = component.props.intl.formatMessage({ id: 'ajaxHandler.errors_404.error_contacte_al_administrador', defaultMessage: 'Contacte al administrador.' });
			}

			if(message) {
				let waitForResponse = new Promise((resolve, reject) => {
					if(response.responseJSON) {
						messageResponse = response.responseJSON.mensaje;
						detailResponse = response.responseJSON.detail;
						resolve();
					} else if(response instanceof Response) {
						response.json()
						.then((data) => {
							messageResponse = data.mensaje;
							detailResponse = data.detail;
							resolve();
						})
						.catch(() => {
							console.log('Error');
						});
					} else {
						resolve();
					}
				});

				waitForResponse.then(() => {
					if(response.status === 401) {
						swal({
							title: message,
							text: detail,
							icon: "error",
							buttons: {
								confirm: {
									text: component.props.intl.formatMessage({ id: 'ajaxHandler.errors_401.error_button_aceptar', defaultMessage: 'Aceptar' }),
									value: true,
									visible: true,
									className: "btn btn-primary",
									closeModal: true
								}
							}
						}).then((isConfirm) => {
							if (isConfirm) {
								window.location.reload();
							}
						});
						resolve(message);
					} else if(response.status === 403) {
						if (!_ajaxHandler403Showing) {
							_ajaxHandler403Showing = true;
							const reset403ModalFlag = function() {
								_ajaxHandler403Showing = false;
							};
							const fallbackResetTimeout = setTimeout(reset403ModalFlag, MODAL_RESET_TIMEOUT_MS);
							const swalPromise = swal({
								title: messageResponse ? messageResponse : message,
								text: detail + (detailResponse ? ('\n' + detailResponse) : ''),
								icon: "error",
								buttons: {
									confirm: {
										text: component.props.intl.formatMessage({ id: 'ajaxHandler.errors_403.error_button_aceptar', defaultMessage: 'Aceptar' }),
										value: true,
										visible: true,
										className: "btn btn-primary",
										closeModal: true
									}
								}
							});
							Promise.resolve(swalPromise)
								.then(reset403ModalFlag)
								.catch(reset403ModalFlag)
								.finally(function() { clearTimeout(fallbackResetTimeout); });
						}
						resolve(message);
					} else if(response.status >= 404) {
						if (!silent) {
							swal({
								title: message,
								text: detail,
								icon: "error",
								buttons: {
									confirm: {
										text: component.props.intl.formatMessage({ id: 'ajaxHandler.errors_404.error_button_aceptar', defaultMessage: 'Aceptar' }),
										value: true,
										visible: true,
										className: "btn btn-primary",
										closeModal: true
									}
								}
							});
						}
						resolve(message);
					}
				})
				.catch(() => {
					console.log('Error');
				});
			} else {
				resolve(null);
			}
		});
	}

	handleError(error) {
		let component = this.component;
		let title = "Error"
		let text = ""
		let button = 'OK'
		if (component && component.props) {
			title = component.props.intl.formatMessage({ id: 'ajaxHandler.errors_handleError.error_interno_del_sistema', defaultMessage: 'Error interno del sistema.' })
			text = component.props.intl.formatMessage({ id: 'ajaxHandler.errors_handleError.contacte_al_administrador', defaultMessage: 'Contacte al administrador.' })
			button = component.props.intl.formatMessage({ id: 'ajaxHandler.errors_handleError.button_aceptar', defaultMessage: 'Aceptar' })
		}
		if(error) {
			swal({
				title: error.message ? error.message : title,
				text: text,
				icon: "error",
				buttons: {
					confirm: {
						text: button,
						value: true,
						visible: true,
						className: "btn btn-primary",
						closeModal: true
					}
				}
			});
		}
	}
}

export default AjaxHandler;
